import React from 'react';

import { TotalBalanceContainer } from './TotalBalance.styled';
import { Text } from 'components/v2/Typography/Text';
import { currencyNumberFormat } from 'utilities/number-format';

export const TotalBalance = ({ value }: { value: number }) => {
  return (
    <TotalBalanceContainer>
      <Text>Total Balance</Text>
      <br />
      <Text fontStyle="bold">{currencyNumberFormat(value)}</Text>
    </TotalBalanceContainer>
  );
};
